import { useEffect } from 'react';

export function useProcessScrollAnimation() {
  useEffect(() => {
    const section = document.querySelector(".process");
    if (!section) return;
    
    const steps = section.querySelectorAll(".process-step");
    const fill = section.querySelector(".process-line-fill");
    if (!steps.length) return;

    let raf = 0;
    
    const update = () => {
      const r = section.getBoundingClientRect();
      const vh = window.innerHeight;
      const start = vh * 0.8;
      const end = vh * 0.2;
      const total = r.height + (start - end);
      const traveled = start - r.top;
      const p = Math.max(0, Math.min(1, traveled / total));
      const activeIdx = Math.min(steps.length - 1, Math.floor(p * steps.length));
      
      steps.forEach((el, i) => {
        el.classList.toggle("past", i < activeIdx);
        el.classList.toggle("active", i === activeIdx && p > 0.02);
      });
      
      if (fill) {
        const pct = Math.min(100, p * 100 * 1.05);
        fill.style.width = pct + "%";
      }
      raf = 0;
    };
    
    const onScroll = () => { 
      if (!raf) raf = requestAnimationFrame(update); 
    };
    
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);
}
